import { useGetEnums } from 'api-hooks/common';
import { OnChangeParams, Option, SelectOverrides } from 'baseui/select';
import { EnumList } from 'common/constants/enum';
import { capitalize } from 'common/utils/string';
import { Input } from 'components/elements';
import * as React from 'react';

interface Props {
  name: string;
  label?: string;
  placeholder?: string;
  enumType: EnumList;
  clearable?: boolean;
  required?: boolean;
  disabled?: boolean;
  hideRequiredStar?: boolean;
  hideLabel?: boolean;
  overrides?: SelectOverrides;
  fieldType?: 'control' | 'uncontrol';
  onAfterChange?: (val: OnChangeParams) => void;
}

export default function EnumSelectInput(props: Props) {
  const { enumType, ...rest } = props;
  const { data, isLoading } = useGetEnums({ class: enumType });

  const uppercaseWord = React.useMemo(() => ['pt', 'cv'], []);

  const options = React.useMemo<Option[]>(() => {
    return (data?.data || []).map((item) => ({
      id: item.value,
      label: uppercaseWord.find((word) => word === item.value)
        ? item.value.toUpperCase()
        : capitalize(item.label),
    }));
  }, [data, uppercaseWord]);

  return (
    <Input
      type="select"
      {...rest}
      options={options}
      disabled={isLoading || rest.disabled}
    />
  );
}
